import { AttributeFieldProps } from "./RenderAttributeInput";
import { GetComponentOrStyleValueFromDefinition } from "../Data/WBData";
import SliderFieldNoLabel from "./SliderFieldNoLabel";


export default function SliderField({hideUpdating, label,definition,layoutObject,updateFunc,screenSize,siteData,saveFunc,allowAuto}:AttributeFieldProps&{hideUpdating?:boolean,allowAuto?:boolean}){

    const val = GetComponentOrStyleValueFromDefinition(definition,layoutObject,screenSize);

    return(
        <div className="wb-input-group" style={{paddingBottom:"8px"}}>
            <label className={(val==""||val=="1"||hideUpdating)?"not-updated":"updated"} >{label}</label>
            <SliderFieldNoLabel allowAuto={allowAuto} definition={definition} layoutObject={layoutObject} updateFunc={updateFunc} saveFunc={saveFunc} screenSize={screenSize} siteData={siteData} label={""}/>
        </div>
    );
}